import React, { useEffect } from 'react';
import { Flex, Select } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { QuestionNextButton } from './QuestionNextButton';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { useTranslation } from 'react-i18next';

const OPTIONS_DROPDOWN = ['Less than 1', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'More than 10'];

export const QuestionAge: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizPetAgePageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers } = useProductQuiz();

  return (
    <>
      <QuestionTitle>{t('how_old_is_name', { name: quizAnswers.petName })}</QuestionTitle>
      <Flex justify="center" align="center" dir="row" style={{ width: '100%', gap: 12 }}>
        <Select
          radius={'xl'}
          dropdownPosition="bottom"
          // Allow text to sit beside select; flex-grow instead of 100% width
          w={undefined}
          style={{ flex: 1, minWidth: 0 }}
          styles={(theme) => ({
            input: { height: 56, fontSize: 16, paddingLeft: '2em', paddingRight: 10, enterkeyhint: 'next' },
            dropdown: {
              borderRadius: 24,
              fontSize: 16,
              padding: 20,
            },
            item: {
              borderRadius: 24,
              padding: 20,
              textAlign: 'center',
              '&[data-hovered]': {
                backgroundColor: theme.colors['gray-300'],
                color: 'black',
              },
              '&[data-selected]': {
                backgroundColor: theme.colors['gray-300'],
                color: 'black',
              },
            },
          })}
          rightSection={<></>}
          data={OPTIONS_DROPDOWN.map((option, index) =>
            index <= 1
              ? t('years_old_singular_text', { value: option })
              : t('years_old_plural_text', { value: option }),
          )}
          value={quizAnswers.age ?? undefined}
          placeholder={t('select_age')}
          onChange={(val) => {
            if (!val) return;
            setQuizAnswers({ ...quizAnswers, age: val });
          }}
        />
      </Flex>
      <QuestionNextButton
        showOnDesktop={true}
        isDisabled={!quizAnswers.age}
        event={() => quizQuestionPage.quizPetAgeNext(quizAnswers.age ?? '')}
      />
    </>
  );
};
